import { userHasOperation } from './permissions'
import { useAuthStore } from '../stores/authStore'

/**
 * True when the signed-in person may change COMPANY-wide settings such as the
 * company's country and timezone — mirrors the API gate on
 * `PATCH /admin/company` (`requireAdminOp('company.manage')` → `canAdmin`): an
 * internal member of a company who holds `company.manage` (Company Admin, Sub
 * Admin). A Master Admin has no company of their own here, and an external
 * collaborator is never an admin, so neither gets the controls.
 */
export function useCanManageCompany() {
  return useAuthStore(
    (s) =>
      Boolean(s.tenant) &&
      s.user?.membershipType !== 'external' &&
      userHasOperation(s.user, 'company.manage'),
  )
}
